var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M14.854 3.646a.5.5 0 0 1 0 .708L5.5 13.707 1.146 9.354a.5.5 0 1 1 .708-.708L5.5 12.293l8.646-8.647a.5.5 0 0 1 .708 0",
  clipRule: "evenodd"
})));
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC44NTM2IDMuNjQ2NDVDMTUuMDQ4OCAzLjg0MTcxIDE1LjA0ODggNC4xNTgyOSAxNC44NTM2IDQuMzUzNTVMNS41IDEzLjcwNzFMMS4xNDY0NSA5LjM1MzU1QzAuOTUxMTg0IDkuMTU4MjkgMC45NTExODQgOC44NDE3MSAxLjE0NjQ1IDguNjQ2NDVDMS4zNDE3MSA4LjQ1MTE4IDEuNjU4MjkgOC40NTExOCAxLjg1MzU1IDguNjQ2NDVMNS41IDEyLjI5MjlMMTQuMTQ2NCAzLjY0NjQ1QzE0LjM0MTcgMy40NTExOCAxNC42NTgzIDMuNDUxMTggMTQuODUzNiAzLjY0NjQ1WiIgZmlsbD0iIzFDMUMxQSIvPgo8L3N2Zz4K";